import React from 'react';
import { LinkedInCallback } from 'react-linkedin-login-oauth2';
import { Route, Routes, BrowserRouter, Navigate } from 'react-router-dom';
import App from './App';
import Login from './Components/Login';
import TicketsGms from './Components/Tasks';
import Dashboard from './Components/Dashboard';
import AddGms from './Components/Tasks/AddGms';
import ProtectedRoute from './protectedRoutes';
import { useSelector } from 'react-redux';
import StepperForm from './Components/Tasks/Stepper';
import PortalCalendar from './Components/PortalCalendar/PortalCalendar';
import Team from './Components/Team/Team';
import Scorecard from './Components/Scorecard/Scorecard';
import Budget from './Components/Budget';
import AddBudget from './Components/Budget/AddBudget';
import BudgetStepperForm from './Components/Budget/Stepper';
import News from './Components/News';
import AddNews from './Components/News/AddNews';
import NewsStepperForm from './Components/News/Stepper';
import Gallery from './Components/Gallery/Gallery';
import UserDetails from './Components/Users';
import AddUser from './Components/Users/Add-User';
import AddVideo from './Components/Videos/AddVideo';
import Videos from './Components/Videos';
import Images from './Components/Images';
import AddImage from './Components/Images/AddImage';
import ViewTtd from './Components/TtdCalendar/ViewTtd';
import AddTtd from './Components/TtdCalendar/AddTtd/AddTtd';
import JobRequests from './Components/JobRequests';

const Routing = (props) => {
  const userToken = useSelector((state) => state.user.token);
  const { role } = useSelector((state) => state.user);
  const allRoutes = () => {
    return (
      <BrowserRouter>
        <Routes>
          <Route
            path="/ttd-calendar"
            element={<Navigate to="/ttd-calendar/approved-list" replace />}
          />
          <Route
            path="/gms"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Manager-Access',
                    'Grievance-Data-Entry-Operator',
                  ]}
                  role={role}
                >
                  <TicketsGms />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/job-requests"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Manager-Access',
                    'Grievance-Data-Entry-Operator',
                  ]}
                  role={role}
                >
                  <JobRequests />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/ttd-calendar/add-edit/ttd-request"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Manager-Access',
                  ]}
                  role={role}
                >
                  <AddTtd />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/ttd-calendar/:tab"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Manager-Access',
                  ]}
                  role={role}
                >
                  <ViewTtd />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/budget"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Manager-Access',
                  ]}
                  role={role}
                >
                  <Budget />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/news"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Web-Portal-Data-Entry',
                  ]}
                  role={role}
                >
                  <News />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Director',
                  ]}
                  role={role}
                >
                  <Dashboard />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Director',
                  ]}
                  role={role}
                >
                  <Dashboard />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/calendar"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Manager-Access',
                    'Director',
                  ]}
                  role={role}
                >
                  <PortalCalendar />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/AddGms"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                    'Grievance-Data-Entry-Operator',
                  ]}
                  role={role}
                >
                  <AddGms />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/AddBudget"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                  ]}
                  role={role}
                >
                  <AddBudget />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/AddNews"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Web-Portal-Data-Entry',
                  ]}
                  role={role}
                >
                  <AddNews />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/stepper-form"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                  ]}
                  role={role}
                >
                  <StepperForm />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/budget-stepper-form"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Grievance-Admin-Access',
                  ]}
                  role={role}
                >
                  <BudgetStepperForm />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/news-stepper-form"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Web-Portal-Data-Entry',
                  ]}
                  role={role}
                >
                  <NewsStepperForm />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/all-users"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={['Super-Admin', 'Admin']}
                  role={role}
                >
                  <UserDetails />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/add-user"
            element={
              userToken ? (
                <ProtectedRoute allowedRoles={['Super-Admin']} role={role}>
                  <AddUser />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/videos"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Web-Portal-Data-Entry',
                  ]}
                  role={role}
                >
                  <Videos />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/add-video"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Web-Portal-Data-Entry',
                  ]}
                  role={role}
                >
                  <AddVideo />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />

          <Route
            path="/images"
            element={
              userToken ? (
                <ProtectedRoute
                  allowedRoles={[
                    'Super-Admin',
                    'Admin',
                    'Web-Portal-Data-Entry',
                  ]}
                  role={role}
                >
                  <Images />
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          />
          {/* <Route
            path="/add-image"
            element={
              userToken ? (
                <ProtectedRoute
                allowedRoles={["Super-Admin", "Admin", "editor"]}
                role={role}
                >
                 <AddImage/>
                </ProtectedRoute>
              ) : (
                <Login />
              )
            }
          /> */}
          <Route path="/seva-login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    );
  };

  return <>{allRoutes(props)}</>;
};

export default Routing;
